import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useAuth } from '../../hooks/auth';
import { useOnboarding } from '../../hooks/onboarding';

const OnboardingController: React.FC = () => {
  const { user } = useAuth();
  const { pathname } = useLocation();
  const { isOnboardingActive, startOnboarding } = useOnboarding();

  // Verificar se deve iniciar o onboarding automaticamente para novos usuários
  useEffect(() => {
    let timeoutId: ReturnType<typeof setTimeout> | undefined;

    if (
      pathname === '/home' &&
      user &&
      !user.onboarding_completed &&
      !user.onboarding_skipped &&
      !isOnboardingActive
    ) {
      // Verificar se é a primeira vez que o usuário acessa
      const firstLogin =
        !user.last_access ||
        new Date(user.last_access).getTime() ===
          new Date(user.registred_at).getTime();

      if (firstLogin) {
        timeoutId = setTimeout(() => {
          startOnboarding();
        }, 5000);
      }
    }

    return () => {
      // Limpar qualquer timeout se o componente for desmontado
      if (timeoutId) {
        clearTimeout(timeoutId);
      }
    };
  }, [pathname, user, isOnboardingActive, startOnboarding]);
  return null;
};

export default OnboardingController;
